export enum FeatureSubscriptionInfoEnums {
    User = 1,
    Workflow = 2,
    Import = 3,
    Export = 4,
    SavedSearch = 5,
    Location = 6,
    Channel = 7,
    Tags = 8
}
